export const requestFormats = {
	unknown: 0,
	print: 1,
	ePub: 2,
	pdf: 3,
	kindle: 4,
	mobi: 5,
	mp3: 11,
	audioZip: 12,
	audioChapters: 13,
	externalUrl: 1000,
	any: 999999,
	anyDigital: 888888,
};
